import { DefaultSectionCopy, Section } from "@hydrologiq/shared/providers/CopyProvider"
import { COPY_KEYS, DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"

const copy: DefaultSectionCopy = {
  type: Section.ORDERS,
  name: "Orders",
  base: "orders",
  routes: [],
  buttons: [
    { name: COPY_KEYS.BUTTONS.CREATE, label: "Create", description: "Add a new order to the system" },
    { name: COPY_KEYS.BUTTONS.ARCHIVE, label: "Delete", description: "Delete the current order" },
    { name: COPY_KEYS.BUTTONS.COLLAPSE, label: "Collapse", description: "Collapse the activities" },
    { name: COPY_KEYS.BUTTONS.EXPAND, label: "Expand", description: "Expand the activities" },
    {
      name: COPY_KEYS.BUTTONS.MANAGE_FULFILMENTS,
      label: "Manage Fulfilments",
      description: "Manage fulfilments for this order",
    },
    { name: COPY_KEYS.BUTTONS.SCHEDULE, label: "Schedule", description: "Schedule the order" },
    { name: COPY_KEYS.BUTTONS.START, label: "Start", description: "Start the order" },
    { name: COPY_KEYS.BUTTONS.COMPLETE, label: "Complete", description: "Complete the order" },
    { name: COPY_KEYS.BUTTONS.BILL, label: "Bill", description: "Bill the order" },
    { name: COPY_KEYS.BUTTONS.EDIT_DETAILS, label: "Edit details", description: "Edit order details" },
    { name: COPY_KEYS.BUTTONS.EDIT_ID, label: "Edit ID", description: "Edit order ID" },
    { name: COPY_KEYS.BUTTONS.SAVE, label: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.SAVE], description: "Save changes" },
    {
      name: COPY_KEYS.BUTTONS.CANCEL,
      label: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.CANCEL],
      description: "Cancel changes",
    },
  ],
  headings: [
    { name: COPY_KEYS.HEADINGS.ORDER, value: "Order" },
    { name: COPY_KEYS.HEADINGS.ORDERS, value: "Orders" },
    { name: COPY_KEYS.HEADINGS.ORDER_ID, value: "Order ID" },
    { name: COPY_KEYS.HEADINGS.ORDER_QUANTITY, value: "Ordered Quantity (kg)" },
    { name: COPY_KEYS.HEADINGS.ORDER_START, value: "Start" },
    { name: COPY_KEYS.HEADINGS.ORDER_END, value: "End" },
    { name: COPY_KEYS.HEADINGS.NAME, value: "Name" },
    { name: COPY_KEYS.HEADINGS.CUSTOMER, value: "Customer" },
    { name: COPY_KEYS.HEADINGS.SITE, value: "Site" },
    { name: COPY_KEYS.HEADINGS.ASSET, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSET] },
    { name: COPY_KEYS.HEADINGS.ASSETS, value: "Assets" },
    { name: COPY_KEYS.HEADINGS.STATUS, value: "Status" },
    { name: COPY_KEYS.HEADINGS.QUANTITY, value: "Quantity (kg)" },
    { name: COPY_KEYS.HEADINGS.SCHEDULED_QUANTITY, value: "Scheduled Quantity (kg)" },
    { name: COPY_KEYS.HEADINGS.ACTUAL_QUANTITY, value: "Actual Quantity (kg)" },
    { name: COPY_KEYS.HEADINGS.QUANTITY_FULFILLED, value: "Planned (kg)" },
    { name: COPY_KEYS.HEADINGS.QUANTITY_CONSUMED, value: "Consumed (kg)" },
    { name: COPY_KEYS.HEADINGS.START_DATE, value: "Start Date" },
    { name: COPY_KEYS.HEADINGS.END_DATE, value: "End Date" },
    { name: COPY_KEYS.HEADINGS.TIMESTAMP, value: "Timestamp" },
    { name: COPY_KEYS.HEADINGS.INFORMATION, value: "Information" },
    { name: COPY_KEYS.HEADINGS.DETAILS, value: "Details" },
    { name: COPY_KEYS.HEADINGS.ACTIVITY, value: "Activity" },
    { name: COPY_KEYS.HEADINGS.ACTIVITIES, value: "Activities" },
    { name: COPY_KEYS.HEADINGS.COMPLETED, value: "Completed" },
    { name: COPY_KEYS.HEADINGS.ACTIONS, value: "Actions" },
    { name: COPY_KEYS.HEADINGS.PERFORM_ACTIONS, value: "Perform actions associated with this order" },
    { name: COPY_KEYS.HEADINGS.EDIT_PREFIX, value: "Edit" },
    // Messages
    { name: COPY_KEYS.MESSAGES.CREATED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.CREATED] },
    { name: COPY_KEYS.MESSAGES.UPDATED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATED] },
    { name: COPY_KEYS.MESSAGES.DELETED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.DELETED] },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_CREATED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_CREATED],
    },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_UPDATED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_UPDATED],
    },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_DELETED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_DELETED],
    },
    { name: COPY_KEYS.MESSAGES.CREATION_FAILED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.CREATION_FAILED] },
    { name: COPY_KEYS.MESSAGES.UPDATE_FAILED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATE_FAILED] },
    { name: COPY_KEYS.MESSAGES.VALIDATION_ERROR, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.VALIDATION_ERROR] },
    { name: COPY_KEYS.MESSAGES.UNEXPECTED_ERROR, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UNEXPECTED_ERROR] },
    {
      name: COPY_KEYS.MESSAGES.PLEASE_PROVIDE_NAME,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.PLEASE_PROVIDE_NAME],
    },
    { name: COPY_KEYS.MESSAGES.ADDING_TO_SYSTEM, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.ADDING_TO_SYSTEM] },
    {
      name: COPY_KEYS.MESSAGES.UPDATING_IN_SYSTEM,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATING_IN_SYSTEM],
    },
    // Forms
    { name: COPY_KEYS.FORMS.PLEASE_PROVIDE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLEASE_PROVIDE] },
    { name: COPY_KEYS.FORMS.PLEASE_SELECT, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLEASE_SELECT] },
    { name: COPY_KEYS.FORMS.ENTER, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.ENTER] },
    { name: COPY_KEYS.FORMS.INFORMATION_BELOW, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.INFORMATION_BELOW] },
    { name: COPY_KEYS.FORMS.HELPER_TEXT_CREATE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.HELPER_TEXT_CREATE] },
    { name: COPY_KEYS.FORMS.HELPER_TEXT_EDIT, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.HELPER_TEXT_EDIT] },
    { name: COPY_KEYS.FORMS.HELPER_TEXT_ORDER, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.HELPER_TEXT_ORDER] },
    {
      name: COPY_KEYS.FORMS.PLACEHOLDER_ENTER_NAME,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLACEHOLDER_ENTER_NAME],
    },
    {
      name: COPY_KEYS.FORMS.END_DATE_BEFORE_START,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.END_DATE_BEFORE_START],
    },
    { name: COPY_KEYS.FORMS.INVALID_DATE_FORMAT, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.INVALID_DATE_FORMAT] },
    { name: COPY_KEYS.FORMS.AT_LEAST_ONE_ASSET, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.AT_LEAST_ONE_ASSET] },
    { name: COPY_KEYS.FORMS.ASSETS_UNAVAILABLE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.ASSETS_UNAVAILABLE] },
    {
      name: COPY_KEYS.FORMS.ASSETS_UNAVAILABLE_MESSAGE,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.ASSETS_UNAVAILABLE_MESSAGE],
    },
    // Labels
    { name: COPY_KEYS.LABELS.NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.NAME] },
    { name: COPY_KEYS.LABELS.START_DATE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.START_DATE] },
    { name: COPY_KEYS.LABELS.END_DATE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.END_DATE] },
    { name: COPY_KEYS.LABELS.CUSTOMER, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.CUSTOMER] },
    { name: COPY_KEYS.LABELS.SITE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.SITE] },
    { name: COPY_KEYS.LABELS.ASSETS, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.ASSETS] },
    { name: COPY_KEYS.LABELS.ORDER_NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.ORDER_NAME] },
    // Actions
    { name: COPY_KEYS.ACTIONS.CREATING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.CREATING] },
    { name: COPY_KEYS.ACTIONS.UPDATING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.UPDATING] },
    { name: COPY_KEYS.ACTIONS.DELETING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.DELETING] },
    // Common
    { name: COPY_KEYS.COMMON.A, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.A] },
    { name: COPY_KEYS.COMMON.AN, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.AN] },
    { name: COPY_KEYS.COMMON.THE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.THE] },
    { name: COPY_KEYS.COMMON.AND, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.AND] },
    { name: COPY_KEYS.COMMON.TO_THE_SYSTEM, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.TO_THE_SYSTEM] },
  ],
  statuses: [],
}

export default copy
